export const spaceSeparatedIncludes = (arr, value) => arr.split(' ').includes(value);
